module.exports = __webpack_public_path__ + "static/media/han-tambuyzer.50e679e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/avatars/han-tambuyzer.jpg
// module id = 822
// module chunks = 0